import React, { useRef } from 'react'

import Results from './Results'
import Input from './Input'
import Filter from './Filter'

import style from './Search.module.scss'

const Search = ({
  engine,
  microcopy
}) => {
  const backdrop = useRef()

  return (
    <div 
      className={style.backdrop}
      data-visible={engine.state.showSearch}
      onClick={ (e) => (e.target === backdrop.current && engine.hide(0)) }
      ref={backdrop}
    >
      <div 
        className={style.search} 
        data-visible={engine.state.showSearch}
      >
        <Input engine={engine} microcopy={microcopy} />
        <Filter engine={engine} microcopy={microcopy} />
        <Results engine={engine} microcopy={microcopy} />
      </div>
    </div>
  )
}

export default Search